<template>
    <ul class="d-flex flex-column align-items-start justify-content-start">      
        <irsh-link-item v-for="link in navLink" :key="link.path"
                                    class="hidden" :class="link.class" data-category="mobile-footer-nav"
                                    :path="link.path" :title="link.title"  />
    </ul>
</template>

<script>
    import NavLinks from "../models/navLinks"
     import LinkItem from "./LinkItem"

    export default {
        components: {
            'irsh-link-item': LinkItem
        },
        data() {            
            return {
                navLink: NavLinks.navHeader().nav
            }
        }
    }
</script>
